<template>
  <div
    ref="flashcard-view-container"
    class="grouping-quiz-view"
  >
    <template v-if="assetAssociation">
      <grouping-quiz-flashcard
        :asset-association="assetAssociation"
        :breadcrumbs="breadcrumbs"
        :flashcards="flashcards"
        :flashcard-states="flashcardStates"
        :grouping="grouping"
        :reviewing="reviewing"
      />
    </template>
    <template v-else>
      <page-header :breadcrumbs="breadcrumbs" />
      <grouping-quiz-overview
        :flashcards="flashcards"
        :flashcard-states="flashcardStates"
        :grouping="grouping"
      />
    </template>
  </div>
</template>

<script>
import GroupingQuizFlashcard from '@/components/groupings/quiz/flashcard';
import GroupingQuizOverview from '@/components/groupings/quiz/overview';
import PageHeader from '@/components/singletons/pageHeader';

export default {
  components: { GroupingQuizFlashcard, GroupingQuizOverview, PageHeader },
  props: {
    assetAssociation: {
      type: Object,
    },
    breadcrumbs: {
      type: Array,
    },
    category: {
      type: Object,
    },
    grouping: {
      type: Object,
    },
  },
  computed: {
    flashcards() {
      return this.grouping.flashcardAssociations
        .map(aa => this.$store.getters['flashcards/flashcards'][aa.assetBId])
        .filter(f => f);
    },
    flashcardStates() {
      return this.grouping.flashcardAssociations
        .map(aa => this.$store.getters['flashcardStates/flashcardStates'][`${aa.assetBId}-asset-association-${aa.id}`])
        .filter(state => state);
    },
    reviewing() {
      if (this.$route.query?.review) {
        return true;
      }
    },
  },
};
</script>